import React, { useState } from 'react';
import { StyledTableAvatar } from '../../styles/TableStyle';
import { Box, Stack, Typography } from '@mui/material';
import { ReactComponent as BlueEnvelop } from '../../assets/images/main-page/envelope-icon.svg';
import { ReactComponent as BlueTel } from '../../assets/images/main-page/tel-icon.svg';
import { ReactComponent as PersonIcon } from '../../assets/images/main-page/person-icon.svg';
import { ReactComponent as Trash } from '../../assets/images/main-page/trash-icon.svg';

function CustomAvatar({
  first_name,
  last_name,
  email,
  phone,
  bottom = '-50px',
  arrow_top = '65%',
  driver = false,
}) {
  const [showDetails, setShowDetails] = useState(false);

  return (
    <Box position="relative">
      <StyledTableAvatar onClick={() => setShowDetails(!showDetails)}>
        {first_name && last_name
          ? first_name?.substring(0, 1) + '.' + last_name?.substring(0, 1)
          : first_name
            ? first_name?.substring(0, 1)
            : last_name?.substring(0, 1)}
      </StyledTableAvatar>
      <Stack
        direction="column !important"
        alignItems="center"
        position="absolute"
        left="55px"
        bottom={bottom}
        backgroundColor="#fff"
        padding="16px"
        borderRadius="20px"
        rowGap="16px"
        boxShadow="0px 8px 24px 0px rgba(141, 175, 189, 0.2)"
        zIndex="1"
        sx={{
          //   transform: 'translateY(-50%)',
          opacity: showDetails ? '1' : '0',
          visibility: showDetails ? 'visible' : 'hidden',
        }}
      >
        <Box
          position="absolute"
          left="-15px"
          top={arrow_top}
          transform="translateY(-50%)"
          width="0"
          height="0"
          borderTop="10px solid transparent"
          borderRight="20px solid #fff"
          borderBottom="10px solid transparent"
        />
        <StyledTableAvatar>
          {first_name && last_name
            ? first_name?.substring(0, 1) + '.' + last_name?.substring(0, 1)
            : first_name
              ? first_name?.substring(0, 1)
              : last_name?.substring(0, 1)}
        </StyledTableAvatar>
        <Typography variant="runningText">
          {first_name && last_name
            ? `${first_name} ${last_name}`
            : first_name
              ? first_name
              : last_name}
        </Typography>
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          columnGap="8px"
          padding="8px 16px"
          border="1px solid rgba(192, 211, 218, 1)"
          borderRadius="30px"
          width="100%"
        >
          <BlueEnvelop />
          <Typography>{email}</Typography>
        </Stack>
        <Stack
          direction="row"
          columnGap="8px"
          padding="8px 16px"
          border="1px solid rgba(192, 211, 218, 1)"
          borderRadius="30px"
          width="100%"
        >
          {driver ? <BlueTel /> : <BlueTel />}
          <Typography>{phone}</Typography>
        </Stack>
        {driver && (
          <Stack
            direction="row"
            alignItems="center"
            columnGap="8px"
            width="100%"
            sx={{
              cursor: 'pointer',
            }}
          >
            <Trash />
            <Typography variant="runningText">מחק נהג</Typography>
          </Stack>
        )}
      </Stack>
    </Box>
  );
}

export default CustomAvatar;
